// Tekil ihale detay PDF'i — detay penceresiyle aynı 5 bölüm (jsPDF + autoTable, Türkçe font)
import { startReport, addHeading, addTable, addKpis, addParagraph, finishReport, stamp } from './reportPdf';
import { formatIhaleField, kontrolListesi, varYok } from '../components/modules/ihaleler/format';
import { computeNakdiIlerleme, getSonGuncelSozlesme, toplamIsArtisOrani, migrateLegacyIhale } from '../components/modules/ihaleler/calc';

const GRAY = [107, 114, 128];

export function exportIhaleDetayPDF(raw, { users = [], displayMoney }) {
  const ihale = migrateLegacyIhale(raw);
  const f = (col) => formatIhaleField(col, ihale[col], { users, displayMoney }) || '-';
  const money = (v) => displayMoney(v) || '-';
  const sonGuncel = getSonGuncelSozlesme(ihale);
  const nakdi = computeNakdiIlerleme(ihale) || ihale.nakdi_ilerleme || '';
  const toplamOran = toplamIsArtisOrani(ihale);

  const kv = (pairs) => {
    const rows = [];
    for (let i = 0; i < pairs.length; i += 2) rows.push([pairs[i][0], pairs[i][1], pairs[i + 1]?.[0] || '', pairs[i + 1]?.[1] || '']);
    return rows;
  };
  const section = (title, pairs) => {
    addHeading(ctx, title, 1);
    addTable(ctx, ['Alan', 'Değer', 'Alan', 'Değer'], kv(pairs), {
      fontSize: 8,
      columnStyles: { 0: { textColor: GRAY, cellWidth: 40 }, 2: { textColor: GRAY, cellWidth: 40 } },
    });
  };

  const ctx = startReport({ title: `İhale Detay Raporu — ${ihale.ihale_no}`, subtitle: ihale.isin_adi || '', orientation: 'portrait', meta: 'İhaleler Modülü' });
  addKpis(ctx, [
    { label: 'Sözleşme Bedeli', value: money(ihale.sozlesme_bedeli) },
    { label: 'Son Güncel Sözleşme', value: sonGuncel > 0 ? money(sonGuncel.toFixed(2).replace('.', ',')) : '-' },
    { label: 'Toplam Hakediş (KDV Dahil)', value: money(ihale.toplam_odenen_hakedis) },
    { label: 'Nakdi İlerleme', value: nakdi ? `${nakdi} %` : '-', sub: ihale.fiziki_ilerleme ? `Fiziki: ${ihale.fiziki_ilerleme} %` : '' },
  ]);

  section('1. Temel Bilgiler', [
    ['Yıl', f('yil')], ['İhale No', f('ihale_no')], ['Kayıt No', f('kayit_no')], ['İhale Tarihi', f('ihale_tarihi')],
    ['İhale Usulü', f('ihale_usulu')], ['Alım Türü', f('alim_turu')], ['Tesis Türü', f('tesis_turu')], ['Sözleşme Türü', f('sozlesme_turu')],
    ['Sözleşme Tarihi', f('sozlesme_tarihi')], ['İşin Adı', f('isin_adi')],
  ]);
  section('2. Sorumlular ve Lokasyon', [
    ['İlgilenen Memur', f('ilgilenen_memur')], ['İlçe', f('ilcesi')],
    ['Konum', ihale.enlem && ihale.boylam ? `${ihale.enlem}, ${ihale.boylam}` : '-'], ['İşi Yapan İdare', f('isi_yapan_idare')],
    ['Ödenek Durumu', f('odenek_durumu')], ['Gelen Ödenek Tarihi', f('odenek_tarihi')],
  ]);
  section('3. Firma ve Durum', [
    ['Durum', f('durumu')], ['İhaleyi Alan Firma', f('ihaleyi_alan_firma')],
    ['Alt Yüklenici Firma', f('alt_yuklenici_firma')], ['Firma İletişim Adresi', f('firma_iletisim_adresi')],
  ]);

  const finans = [['Yaklaşık Maliyet', money(ihale.yaklasik_maliyet)], ['Sözleşme Bedeli', money(ihale.sozlesme_bedeli)]];
  [1, 2, 3].forEach(i => {
    const aktif = ihale[`is_artisi_${i}_var_mi`] === 'var' || !!ihale[`is_artis_tutari_${i}`];
    finans.push([`${i}. İş Artışı/Azalışı`, aktif ? 'VAR' : (varYok(ihale[`is_artisi_${i}_var_mi`]) || '-')]);
    if (aktif) {
      finans.push([`${i}. Tutar`, money(ihale[`is_artis_tutari_${i}`])]);
      finans.push([`${i}. Oran`, ihale[`is_artis_orani_${i}`] ? `${ihale[`is_artis_orani_${i}`]} %` : '-']);
      finans.push([`${i}. Güncel Sözleşme${i === 3 ? ' (FINAL)' : ''}`, money(ihale[`guncel_sozlesme_bedeli_${i}`])]);
    }
  });
  finans.push(
    ['Toplam İş Artış Oranı', toplamOran ? `${toplamOran} %` : '-'], ['Son Güncel Sözleşme', sonGuncel > 0 ? money(sonGuncel.toFixed(2).replace('.', ',')) : '-'],
    ['Toplam Ödenen Hakediş', money(ihale.toplam_odenen_hakedis)], ['Nakdi İlerleme', nakdi ? `${nakdi} %` : '-'],
    ['Fiziki İlerleme', f('fiziki_ilerleme')], ['Fiyat Farkı', f('fiyat_farki')],
    ['Fiyat Farkı Tutarı', money(ihale.fiyat_farki_tutari)], ['İş Artışı/Süre Uzatımı', f('is_artisi_var_mi')],
  );
  if (ihale.is_artisi_var_mi === 'var') {
    finans.push(['Ek Kesin Teminat', f('ek_kesin_teminat')], ['Revize İş Programı', f('revize_is_programi')], ['İlave All Risk', f('ilave_all_risk')]);
  }
  section('4. Finansal Bilgiler', finans);

  section('5. Süre ve Kabul', [
    ['Yer Teslim Tarihi', f('yer_teslim_tarihi')], ['İşin Süresi (Gün)', f('isin_suresi')],
    ['Bitiş Tarihi', f('bitis_tarihi')], ['Süre Uzatımı (Gün)', f('ilave_sure')],
    ['İlave Süreli İş Bitim', f('sure_uzatimi')], ['Geçici Kabul Tarihi', f('gecici_kabul_tarihi')],
    ['Teminat Süresi (Ay)', f('teminat_suresi_ay')], ['Kesin Kabul Tarihi', f('kesin_kabul_tarihi')],
    ['Kesin Kabul Durumu', f('kesin_kabul_durumu')], ['Kesin Teminat Mektubu', money(ihale.kesin_teminat_mektubu)],
  ]);

  addHeading(ctx, 'Kontrol Teşkilatı', 2);
  addParagraph(ctx, kontrolListesi(ihale.kontrol_teskilati, users).join(', ') || '-');
  if (ihale.aciklama) { addHeading(ctx, 'Açıklama', 2); addParagraph(ctx, ihale.aciklama); }

  finishReport(ctx, `ihale-detay-${String(ihale.ihale_no || '').replace(/\//g, '-')}-${stamp()}.pdf`);
}
